import React, {ReactNode, useEffect, useState} from "react";
import {useAuth} from "../context/AuthContext";
import {Roles} from "../components/common/roles";
import {Navigate, useLocation} from "react-router-dom";
import Cookies from "js-cookie";
import Loader from "../components/common/Loader";

interface AuthLayoutProps {
    children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    //console.log("HERE I")
    const { user, isAuthenticated, login } = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    // Check for persisted auth on mount
    useEffect(() => {
        const token = Cookies.get('accessToken');
        if (token && !isAuthenticated) {
            // Re-authenticate using the stored token
            login(token);
        }
        setIsLoading(false);
    }, [isAuthenticated, login]);

    if (isLoading) {
        return <Loader />;
    }

    if (!isAuthenticated || !user) {
        return <Navigate to="/" />;
    }

    // Check if the current path requires admin access
    const isAdminPath = location.pathname.startsWith('/admin');
    const isGuidePath = location.pathname.startsWith('/guide');
    const isCoordinatorPath = location.pathname.startsWith('/coordinator');

    if (isAdminPath && user.role[0] !== Roles.ADMIN) {
        return <Navigate to="/" />;
    }

    if (isGuidePath && user.role[0] !== Roles.GUIDE) {
        return <Navigate to="/" />;
    }

    if (isCoordinatorPath && user.role[0] !== Roles.COORDINATOR) {
        return <Navigate to="/" />;
    }

    return <>{children}</>;
}

export default AuthLayout;
